import React from 'react';
import { Translation } from 'react-i18next';

export const t = (message) => <Translation>{(t) => t(message)}</Translation>;
